import React, { FC, useState } from 'react';

import { ExclamationCircleOutlined, PaperClipOutlined } from '@ant-design/icons';
import { getECheck } from '@api/FW/ECheck/ECheck';
import { apiErrorHandler } from '@app/services/error.service';
import { RequestSignedBill } from '@FW/components/ECheckModal/components/RequestSignedBill';
import { useResponsive } from '@hooks/shared/useResponsive';
import { Button, Flex, Modal, Spin, Typography } from 'antd';
import { t } from 'i18next';

const { Text } = Typography;

interface IECheckModalProps {
	checkId: string;
	checkNumber: string;
}

const ECheckModal: FC<IECheckModalProps> = ({ checkId, checkNumber }) => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [checks, setChecks] = useState<string[]>([]);

	const { mobileOnly, tabletOnly } = useResponsive();

	const fetchCheckData = () => {
		setIsLoading(true);
		setIsModalOpen(true);

		getECheck(checkId)
			.then((loadData) => {
				setChecks(loadData);
			})
			.finally(() => setIsLoading(false))
			.catch((error) => apiErrorHandler(error));
	};

	return (
		<>
			<Flex
				vertical
				align={mobileOnly || tabletOnly ? 'flex-end' : 'center'}
				gap={10}
				style={{ padding: '8px 0' }}>
				<Text>{checkNumber}</Text>

				<Button onClick={fetchCheckData} className='text-green p-0--i' type='link'>
					<Text style={{ textDecoration: 'underline' }}>{t('transactions.EChecksCTA')}</Text>
				</Button>
			</Flex>
			<Modal
				title={t('transactions.EChecksModalTitle')}
				open={isModalOpen}
				onCancel={() => setIsModalOpen(false)}
				footer={
					<Flex>
						<Text className='text-gray'>{t('transactions.EChecksModalNote')}</Text>
					</Flex>
				}
				destroyOnClose>
				<Spin style={{ padding: '32px 16px' }} spinning={isLoading}>
					<Flex className='mt-20' style={{ minHeight: 200 }} gap={16} wrap='wrap'>
						<RequestSignedBill checkId={checkId} />
						{!isLoading && !checks.length && (
							<Flex gap={8} align='center' className='w-full h-full'>
								<Text className='text-red'>
									<ExclamationCircleOutlined className='mr-10' style={{ fontSize: 20 }} />
									{t('transactions.EChecksNotFound')}
								</Text>
							</Flex>
						)}

						{checks.map((item, index) => (
							<Button key={item}>
								<a target='_blank' href={item} rel='noreferrer'>
									<PaperClipOutlined />{' '}
									<Text>{t(`transactions.ECheck${index === 0 ? 'Main' : 'Return'}`)}</Text>
								</a>
							</Button>
						))}
					</Flex>
				</Spin>
			</Modal>
		</>
	);
};

export default ECheckModal;
